import React from 'react';
import { Link } from "react-router-dom";
import store from '../../store';
import { FooterIcon } from './FooterIcons';
import * as utils from "../../basics/utils";

export const FooterItem = ({ index, link, type, label, callback }) => {
    const { unitHeight, toolbarHeight, toolbarType, online, currentContainer } = store.getState().app;

    let active = true;

    if (currentContainer === '') {
        if (['portfolios', 'icons', 'sites', 'more'].includes(type)) active = false;
    }

    //if (type === 'download' || type === 'versions') active = true;

    if (!online) {
        if (['users', 'icons', 'versions', 'download', 'sites'].includes(type)) active = false;
    }

    const newVersionExists = () => {
        return false;
    }

    const renderButton = () => {

        const renderImage = () => {

            const height = unitHeight * .45;
            const width = height;

            return (
                <FooterIcon type={type} width={width} height={height} toolbarType={toolbarType} active={active} />
            );
        }

        const renderLabel = () => {
            const style = { color: (type === toolbarType) ? 'rgb(68,146,247)' : 'gray' };
            const styleLabel = Object.assign(style, utils.getStyleHeight(unitHeight, .25, .25, .16));

            return <div style={styleLabel} className="w-full outline-none no-underline">{label}</div>;
        }

        const renderBadge = () => {
            // roter Badge am sync-Button anzeigen, wenn auf dem Server eine neue Version vorliegt
            if (type !== 'sync' || !newVersionExists()) return null;

            const style = {
                width: (toolbarHeight * .25) + 'px',
                marginLeft: (toolbarHeight * .25) + 'px',
            };

            const styleBadge = Object.assign(style, utils.getStyleHeight(toolbarHeight, .25, .25, .12));

            return (
                <div style={styleBadge} className="absolute bg-red-600 rounded-full text-white">1</div>
            )
        }

        // ###############################################################
        // renderButton()
        // ###############################################################
        return (
            <div className={"w-full h-full flex flex-col text-center justify-center items-center"}>
                {renderBadge()}
                {renderImage()}
                {renderLabel()}
            </div>
        )
    }

    // ###############################################################
    // renderItem()
    // ###############################################################

    const onClick = () => {
        if (!active) return;
        callback && callback(type)
    }

    const className = "w-1/6 flex no-underline hover:no-underline font-normal cursor-pointer";

    if (link === null) {
        return (<div key={index} className={className} onClick={onClick}>{renderButton()}</div>)
    } else {
        if (active) {
            return (<Link key={index} to={link} className={className} onClick={onClick}>{renderButton()}</Link>)
        } else {
            return (<div key={index} className={className} onClick={onClick}>{renderButton()}</div>)

        }
    }
}

export const FooterItemDownload = ({ index, link, type, label, badge, callback }) => {
    const { unitHeight, toolbarHeight, toolbarType, online } = store.getState().app;

    const renderButton = () => {

        const renderImage = () => {

            const height = unitHeight * .5;
            const width = height;

            return (
                <FooterIcon type={type} width={width} height={height} toolbarType={toolbarType} active={online} />
            );
        }

        const renderLabel = () => {
            const style = { color: (type === toolbarType) ? 'rgb(68,146,247)' : 'darkgray' };
            const styleLabel = Object.assign(style, utils.getStyleHeight(unitHeight, .25, .25, .16));

            return <div style={styleLabel} className="w-full outline-none no-underline">{label}</div>;
        }

        const renderBadge = () => {
            // roter Badge am sync-Button anzeigen, wenn auf dem Server eine neue Version vorliegt
            if (type !== 'sync' || !badge) return null;

            const style = {
                width: (toolbarHeight * .15) + 'px',
                marginTop: -(toolbarHeight * .24) + 'px',
            };

            const styleBadge = Object.assign(style, utils.getStyleHeight(toolbarHeight, .15, .15, .15));

            return (
                <div style={styleBadge} className="absolute bg-white rounded-full text-white"></div>
            )
        }

        // ###############################################################
        // renderButton()
        // ###############################################################
        return (
            <div className={"w-full h-full flex flex-col text-center justify-center items-center"}>
                {renderBadge()}
                {renderImage()}
                {renderLabel()}
            </div>
        )
    }

    // ###############################################################
    // renderItem()
    // ###############################################################

    const onClick = () => {
        callback && callback(type)
    }

    const className = "w-1/6 flex no-underline hover:no-underline font-light cursor-pointer";

    if (link === null) {
        return (<div key={index} className={className} onClick={onClick}>{renderButton()}</div>)
    } else {
        return (<Link key={index} to={link} className={className} onClick={onClick}>{renderButton()}</Link>)
    }
}

export const FooterItemCatalog = ({ index, link, type, label, badge, callback }) => {
    const { unitHeight, toolbarHeight, toolbarType, online } = store.getState().app;

    const renderButton = () => {

        const renderImage = () => {

            const height = unitHeight * .33;
            const width = height;

            return (
                <FooterIcon type={type} width={width} height={height} toolbarType={toolbarType} active={online} />
            );
        }

        const renderLabel = () => {
            const style = { color: (type === toolbarType) ? 'rgb(68,146,247)' : 'gray' };
            const styleLabel = Object.assign(style, utils.getStyleHeight(unitHeight, .25, .25, .12));

            return <div style={styleLabel} className="w-full outline-none no-underline">{label}</div>;
        }

        const renderBadge = () => {
            // roter Badge am sync-Button anzeigen, wenn auf dem Server eine neue Version vorliegt
            if (type !== 'sync' || !badge) return null;

            const style = {
                width: (toolbarHeight * .25) + 'px',
                marginLeft: (toolbarHeight * .25) + 'px',
            };

            const styleBadge = Object.assign(style, utils.getStyleHeight(toolbarHeight, .25, .25, .12));

            return (
                <div style={styleBadge} className="absolute bg-red-600 rounded-full text-white"></div>
            )
        }

        // ###############################################################
        // renderButton()
        // ###############################################################
        return (
            <div className={"w-full h-full flex flex-col text-center justify-center items-center"}>
                {renderBadge()}
                {renderImage()}
                {renderLabel()}
            </div>
        )
    }

    // ###############################################################
    // renderItem()
    // ###############################################################

    const onClick = () => {
        callback && callback(type)
    }

    const className = "w-1/6 flex no-underline hover:no-underline font-light cursor-pointer";

    if (link === null) {
        return (<div key={index} className={className} onClick={onClick}>{renderButton()}</div>)
    } else {
        return (<Link key={index} to={link} className={className} onClick={onClick}>{renderButton()}</Link>)
    }
}